<section>
    <div class="container">
        <div class="row">
            <div class="col_1">
                <div class="img-wrapper">
                    <img src="./assets/img/01.jpg">
                </div>
            </div>

            <div class="col_2">
                <h2 class="s-font">
                    <span>About</span>
                    <span class="color-orange">ALLRENU</span>
                </h2>
                <p>
                    올레뉴는 코스메슈티컬 올인원 맞춤형 화장품 전문기업으로 자체 연구소를 기반으로 <br />
                    제조사 삼성메디코스와 협력하여 피부에 효과적인 천연 성분으로 피부 솔루션을 제공하는<br />
                    올인원 맞춤형 전문 화장품 회사입니다.
                </p>
                <a class="w-btn rounded-btn medium-btn s-font" href="/celljeune-kr/about-us">
                    <span>MORE</span>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path
                            d="M0 6.00008L5.99996 6.00008M5.99996 6.00008L12 6.00008M5.99996 6.00008V0M5.99996 6.00008V12"
                            stroke="#584E3F" stroke-width="1" />
                    </svg>
                </a>
            </div>
        </div>
    </div>
    <img class="e-img" src="./assets/img/01.png">

</section>